document.addEventListener('click', function (e) {

    const btnAbrir = e.target.closest('#modalProduccionSoplado #btnAgregarPncSoplado');

    if (btnAbrir) {
        const modalPadre = document.querySelector('#modalProduccionSoplado');
        const idEncabezado = modalPadre.querySelector('#idReporteSoplado').value;
        const modalHijo = document.querySelector('#modalAgregarPncSoplado');

        if (!idEncabezado || !modalHijo){
            console.error("No se encontró el ID del encabezado o el modal hijo.");
            window.location.reload();
            return;
        }

        const inputIdEncabezado = modalHijo.querySelector('#idEncabezadoReporteSoplado');

        if (!inputIdEncabezado) {
            console.error("No se encontró el input para el ID del encabezado en el modal hijo.");
            window.location.reload();
            return;
        }
        inputIdEncabezado.value = idEncabezado;
    }
});